import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldNotUseInterceptorCheck(req)) {
      const accessToken = localStorage.getItem('accessToken'); 
      const modifiedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${accessToken}`)
                            .set('x-caller-service', 'ProviderPortal')
      });
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
  private shouldNotUseInterceptorCheck(req: HttpRequest<any>): boolean {
    return req.url.includes('/oauth/token')||req.url.includes('/authorization/token');
  }
}